import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AddParticipantModalModule } from '../add-participant-modal/add-participant-modal.module';
import { AudioVideoConferenceComponent } from './audio-video-conference.component';
import { JobMatchProfileOnConferenceModule } from '../job-match-profile-on-conference/job-match-profile-on-conference.module';

@NgModule({
  declarations: [
    AudioVideoConferenceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    InfoIconModule,
    PipesModule,
    AddParticipantModalModule,
    JobMatchProfileOnConferenceModule
  ],
  exports: [
    AudioVideoConferenceComponent
  ],
  entryComponents: [
    AudioVideoConferenceComponent
  ],
  // `candidate-profile` is referenced in dead markup (the audio-video-conference
  // template's `context === 'candidateCard'` branch, which is never true for this
  // component's actual bindings) and remains an AngularJS-only component; schema
  // suppresses the "unknown element" build error for it, matching the precedent at
  // src/app/app.module.ts / src/app/features/header/header.module.ts.
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AudioVideoConferenceModule { }
